(() => {
  const selectors = {
    submenuLink: '.headerDs__menuItemSubmenu',
    submenu: '.headerDs__menuSubmenu',
    burger: '.headerDs__burger',
    mobileNavigation: '.headerDs__aside',
    announcementBar: '.global-anouncement-bar',
    burgerClose: '.headerDs__asideTopCloseWrapper',
    body: 'body',
    headerOverlay: '.headerOverlay',
    menuParentLink: '.headerDs__menuItemParent',
    asideMenuParent: '.headerDs__asideMenuItemParent',
    asideMenu: '.headerDs__asideMenu',
    asideMunuItemHeader: '.headerDs__asideMenuItemHeader',
    asiderMenuItemList: '.headerDs__asideMenuItemListWrapper',

    submenuItemActiveClass: 'headerDs__menuItemSubmenu--active',
    submenuActiveClass: 'headerDs__menuSubmenu--active',
    mobileNavigationActiveClass: 'headerDs__aside--active',
    announcementHiddenClass: 'global-announcement--hidden',
    bodyOverflowClass: 'body--overflow',
    headerOverlayActiveClass: 'headerOverlay--active',
    asideMenuParentActiveClass: 'headerDs__asideMenuItemParent--active',
    noPaddingClass: 'no-padding'
  }

  const submenuLink = document.querySelector(selectors.submenuLink);
  const submenu = document.querySelector(selectors.submenu);
  const burger = document.querySelector(selectors.burger);
  const burgerClose = document.querySelector(selectors.burgerClose);
  const menuParentLink = document.querySelectorAll(selectors.menuParentLink);
  const asideMenuHeaderArray = document.querySelectorAll(selectors.asideMunuItemHeader);

  let timeoutId;
  let isMouseOverMenu = false;

  function closeSubmenu() {
    const headerOverlay  = document.querySelector(selectors.headerOverlay);
    clearTimeout(timeoutId);
    isMouseOverMenu = false;

    timeoutId = setTimeout(() => {
      if (!isMouseOverMenu) {
        submenuLink.classList.remove(selectors.submenuItemActiveClass);
        submenu.classList.remove(selectors.submenuActiveClass);
        headerOverlay.classList.remove(selectors.headerOverlayActiveClass);
      }
    }, 300);
  }

  function showSubmenu() {
    const headerOverlay  = document.querySelector(selectors.headerOverlay);
    isMouseOverMenu = true;
    submenuLink.classList.add(selectors.submenuItemActiveClass);
    submenu.classList.add(selectors.submenuActiveClass);
    headerOverlay.classList.add(selectors.headerOverlayActiveClass);
  };

  function openMobileNavigation() {
    const mobileNavigation = document.querySelector(selectors.mobileNavigation);
    const announcementBar = document.querySelector(selectors.announcementBar);
    const body = document.querySelector(selectors.body);
    const html = document.documentElement;

    mobileNavigation.classList.add(selectors.mobileNavigationActiveClass);
    announcementBar.classList.add(selectors.announcementHiddenClass);
    body.classList.add(selectors.bodyOverflowClass);
    html.classList.add(selectors.noPaddingClass);
  };

  function closeMobileNavigation() {
    const mobileNavigation = document.querySelector(selectors.mobileNavigation);
    const announcementBar = document.querySelector(selectors.announcementBar);
    const body = document.querySelector(selectors.body);
    const html = document.documentElement;

    mobileNavigation.classList.remove(selectors.mobileNavigationActiveClass);
    announcementBar.classList.remove(selectors.announcementHiddenClass);
    body.classList.remove(selectors.bodyOverflowClass);
    html.classList.remove(selectors.noPaddingClass);
  };

  function showChildList() {
    const headerOverlay  = document.querySelector(selectors.headerOverlay);

    headerOverlay.classList.add(selectors.headerOverlayActiveClass);
  };

  function closeChildList() {
    const headerOverlay  = document.querySelector(selectors.headerOverlay);

    headerOverlay.classList.remove(selectors.headerOverlayActiveClass);
  };

  function toggleTab(title) {
    const asideMenu = document.querySelector(selectors.asideMenu);
    const activeTab = asideMenu.querySelector(`.${selectors.asideMenuParentActiveClass}`);
    const currentTab = title.closest(selectors.asideMenuParent);
    const currentTabList = currentTab.querySelector(selectors.asiderMenuItemList);

    if (activeTab && activeTab != currentTab) {
      const activeTabList = activeTab.querySelector(selectors.asiderMenuItemList);

      activeTab.classList.remove(selectors.asideMenuParentActiveClass);
      activeTabList.style.height = '0';
    }

    if (currentTab.classList.contains(selectors.asideMenuParentActiveClass)) {
      currentTab.classList.remove(selectors.asideMenuParentActiveClass);
      currentTabList.style.height = `0`;
    } else {
      currentTab.classList.add(selectors.asideMenuParentActiveClass);
      currentTabList.style.height = `${currentTabList.scrollHeight}px`;
    }
  };

  if (submenuLink && submenu) {
    submenuLink.addEventListener('mouseover', showSubmenu);
    submenu.addEventListener('mouseover', showSubmenu);
    submenuLink.addEventListener('mouseout', closeSubmenu);
    submenu.addEventListener('mouseout', closeSubmenu);
  };

  asideMenuHeaderArray.forEach(header => {
    header.addEventListener('click', (event) => {
      toggleTab(event.currentTarget);
    })
  });

  burger.addEventListener('click', openMobileNavigation);
  burgerClose.addEventListener('click', closeMobileNavigation);

  menuParentLink.forEach(link => {
    link.addEventListener('mouseover', showChildList);
    link.addEventListener('mouseleave', closeChildList);
  });
})();
